import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  doc,
  collection,
  getDocs,
  deleteDoc,
  getDoc,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebase";
import "./SevakListGroup.css"; // Importing custom styles
import generateGroupPDF from "./GroupMembersPDF"; // Adjust path as needed
import { Button } from "react-bootstrap"; // Using React Bootstrap
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { query, where } from "firebase/firestore";

const SevakListGroup = () => {
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [confirmInput, setConfirmInput] = useState("");
  const [user, setUser] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
const [confirmEditInput, setConfirmEditInput] = useState("");
const [editGroupData, setEditGroupData] = useState({
  groupName: "",
  location: "",
  mobile: "",
});



  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchGroups = async () => {
      if (!user) return;

      try {
        const groupsRef = collection(db, "sevakGroups");
        const q = query(groupsRef, where("createdBy.uid", "==", user.uid));
        const querySnapshot = await getDocs(q);

        const groupList = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const leader = data.members?.find(
            (m) => m.designation?.toLowerCase() === "leader"
          );
          return {
            id: doc.id,
            groupId: data.accountId || data.groupId,
            groupName: data.groupName,
            station: data.station,
            leaderName: data.leaderName || "Not Assigned",
            leaderMobile: data.mobile || "-",
            totalMembers: data.members?.length || 0,
          };
        });

        setGroups(groupList);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    fetchGroups();
  }, [user]);

  const handleGroupClick = (groupId) => {
    navigate(`/group/${groupId}`);
  };
  const handleDeleteGroup = async (groupId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this group and all its data?"
    );
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "sevakGroups", groupId));
      setGroups((prev) => prev.filter((group) => group.groupId !== groupId));
      alert("Group deleted successfully.");
    } catch (error) {
      console.error("Error deleting group:", error);
      alert("Failed to delete group.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Sevak Groups List</h3>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Group ID</th>
            <th>Group Name</th>
            <th>Leader Name</th>
            <th>Contact</th>
            <th>Total Members</th>
            <th>Action</th>
            <th>Download PDF</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group, index) => (
            <tr key={group.id}>
              <td>{index + 1}</td>
              <td>{group.groupId}</td>
              <td>{group.groupName}</td>
              <td>{group.leaderName}</td>
              <td>{group.leaderMobile}</td>
              <td>{group.totalMembers}</td>
              <td>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => handleGroupClick(group.groupId)}
                >
                  Open
                </button>
              </td>

              <td>
                <Button
                  variant="outline-primary"
                  className="me-3"
                  // onClick={() => generateGroupPDF(group)}
                  onClick={async () => {
                    try {
                      const docRef = doc(db, "sevakGroups", group.id); // Use Firestore doc ID
                      const docSnap = await getDoc(docRef);
                      if (docSnap.exists()) {
                        const fullGroupData = docSnap.data();
                        fullGroupData.groupId = group.groupId; // Ensure groupId is present
                        fullGroupData.groupName = group.groupName;
                        await generateGroupPDF(fullGroupData); // ✅ Pass full data
                      } else {
                        alert("Group data not found.");
                      }
                    } catch (error) {
                      console.error("Error generating PDF:", error);
                      alert("Failed to generate PDF.");
                    }
                  }}
                >
                  Download PDF
                </Button>
              </td>

              <td>
  <Button
    variant="outline-warning"
    onClick={() => {
      setSelectedGroup(group);
      setConfirmEditInput("");
      
setEditGroupData({
  groupName: group.groupName,
  location: group.location,
  mobile: group.leaderMobile,
  imageFolderPath: group.imageFolderPath || "", 
});

      setShowEditModal(true);
    }}
  >
    ✏️ Edit
  </Button>
</td>

              <td>
                <button
                  className="btn btn-sm"
                  onClick={() => {
                    setSelectedGroup(group);
                    setConfirmInput("");
                    setShowModal(true);
                  }}
                >
                  X
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showModal && selectedGroup && (
        <div className="modal-backdrop">
          <div className="modal-dialog">
            <div className="modal-content p-4">
              <h5>Confirm Deletion</h5>
              <p>
                Do you want to delete <strong>{selectedGroup.groupName}</strong>{" "}
                Group?
              </p>
              <p>Enter Group Account ID to confirm:</p>
              <input
                type="text"
                className="form-control mb-3"
                value={confirmInput}
                onChange={(e) => setConfirmInput(e.target.value)}
              />
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  disabled={confirmInput !== selectedGroup.groupId}
                  onClick={async () => {
                    try {
                      await deleteDoc(doc(db, "sevakGroups", selectedGroup.id));
                      setGroups((prev) =>
                        prev.filter((g) => g.id !== selectedGroup.id)
                      );
                      setShowModal(false);
                      alert("Group deleted successfully.");
                    } catch (error) {
                      console.error("Error deleting group:", error);
                      alert("Failed to delete group.");
                    }
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{showEditModal && selectedGroup && (
  <div className="modal-backdrop">
    <div className="modal-dialog">
      <div className="modal-content p-4">
        <h5>Edit Group Details</h5>
        <p>
          Enter Group Account ID (<strong>{selectedGroup.groupId}</strong>) to confirm:
        </p>
        <input
          type="text"
          className="form-control mb-3"
          value={confirmEditInput}
          onChange={(e) => setConfirmEditInput(e.target.value)}
        />

        {confirmEditInput === selectedGroup.groupId && (
          <>
            <div className="mb-2">
              <label>Group Name</label>
              <input
                type="text"
                className="form-control"
                value={editGroupData.groupName}
                onChange={(e) =>
                  setEditGroupData((prev) => ({
                    ...prev,
                    groupName: e.target.value,
                  }))
                }
              />
            </div>
            {/* <div className="mb-2">
              <label>Location</label>
              <input
                type="text"
                className="form-control"
                value={editGroupData.location}
                onChange={(e) =>
                  setEditGroupData((prev) => ({
                    ...prev,
                    location: e.target.value,
                  }))
                }
              />
            </div> */}
            <div className="mb-2">
              <label>Mobile</label>
              <input
                type="text"
                className="form-control"
                value={editGroupData.mobile}
                onChange={(e) =>
                  setEditGroupData((prev) => ({
                    ...prev,
                    mobile: e.target.value,
                  }))
                }
              />
            </div>

            
<div className="mb-2">
      <label>Image Folder Path</label>
      <input
        type="text"
        className="form-control"
        value={editGroupData.imageFolderPath || ""}
        placeholder={editGroupData.imageFolderPath ? "" : "No path set yet"}
        onChange={(e) =>
          setEditGroupData((prev) => ({
            ...prev,
            imageFolderPath: e.target.value,
          }))
        }
      />
    </div>

          </>



        )}

        <div className="d-flex justify-content-end mt-3">
          <button
            className="btn btn-secondary me-2"
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={confirmEditInput !== selectedGroup.groupId}
            onClick={async () => {
              try {
                const groupRef = doc(db, "sevakGroups", selectedGroup.id);
                await updateDoc(groupRef, {
                  groupName: editGroupData.groupName,
                  // location: editGroupData.location,
                  mobile: editGroupData.mobile,
                  imageFolderPath: editGroupData.imageFolderPath,
                });

                setGroups((prev) =>
                  prev.map((g) =>
                    g.id === selectedGroup.id
                      ? {
                          ...g,
                          groupName: editGroupData.groupName,
                          location: editGroupData.station || "no",
                          leaderMobile: editGroupData.mobile,
                          imageFolderPath: editGroupData.imageFolderPath,
                        }
                      : g
                  )
                );

                setShowEditModal(false);
                alert("Group updated successfully.");
              } catch (error) {
                console.error("Error updating group:", error);
                alert("Failed to update group.");
              }
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default SevakListGroup;
